import type { JSX, ReactNode } from 'react'

import {
  ChannelPostPreview,
  PreviewEnvironmentProvider,
} from '~publish/components/Composer/components/ChannelPostPreview'
import type { PreviewEnvironment } from '~publish/components/Composer/components/ChannelPostPreview'
import SimpleErrorBoundary from '~publish/components/ErrorBoundary/simpleErrorBoundary'
import { getGuestNetworkService } from '~publish/helpers/guestNetworks'
import type { GuestNetwork } from '~publish/helpers/guestNetworks'
import type { Image } from '~publish/legacy/composer/composer/entities/factories'

import {
  buildGuestDraftPreview,
  buildGuestProfilePreview,
} from './guestPreviewAdapter'

const GUEST_PREVIEW_ENVIRONMENT: PreviewEnvironment = {
  scrapeLinks: false,
  readComposerStores: false,
}

export function GuestChannelPreview({
  network,
  text,
  images,
  fallback,
}: {
  network: GuestNetwork
  text: string
  images: readonly Image[]
  fallback: ReactNode
}): JSX.Element {
  return (
    <PreviewEnvironmentProvider value={GUEST_PREVIEW_ENVIRONMENT}>
      <SimpleErrorBoundary fallbackComponent={(): ReactNode => fallback}>
        <ChannelPostPreview
          service={getGuestNetworkService(network)}
          draft={buildGuestDraftPreview({ text, images })}
          profile={buildGuestProfilePreview(network)}
        />
      </SimpleErrorBoundary>
    </PreviewEnvironmentProvider>
  )
}
